"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const get1DDataXY_1 = require("../../data/data1d/Spectrum1D/get1DDataXY");
const isSpectrum1D_1 = require("../../data/data1d/Spectrum1D/isSpectrum1D");
const ChartContext_1 = require("../context/ChartContext");
const useActiveSpectra_1 = require("../hooks/useActiveSpectra");
const Line_1 = __importDefault(require("./Line"));
function LinesSeries() {
    const { data, displayerKey, xDomains } = (0, ChartContext_1.useChartData)();
    const activeSpectra = (0, useActiveSpectra_1.useActiveSpectra)();
    const spectra = (data?.filter((d) => (0, isSpectrum1D_1.isSpectrum1D)(d) && d.display.isVisible && xDomains[d.id]) || []);
    return ((0, jsx_runtime_1.jsxs)("g", { clipPath: `url(#${displayerKey}clip-chart-1d)`, className: "spectrums", children: [spectra.map((d, i) => ((0, jsx_runtime_1.jsx)("g", { id: d.id, children: (0, jsx_runtime_1.jsx)(Line_1.default, { display: d.display, id: d.id, data: (0, get1DDataXY_1.get1DDataXY)(d), index: i }) }, d.id))), activeSpectra?.map((activeSpectrum) => ((0, jsx_runtime_1.jsx)("use", { href: `#${activeSpectrum.id}` }, activeSpectrum.id)))] }));
}
exports.default = LinesSeries;
